function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Avatar as ChakraAvatar, forwardRef, createMultiStyleConfigHelpers } from "../../chakra/internal";
import { mergeRefs } from "../../chakra/internal";
import { avatarAnatomy } from "../../chakra/internal";
import { getTypographyStyles } from "../../typography";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(avatarAnatomy.keys);
const variants = {
    neutral: definePartsStyle({
        container: {
            borderRadius: 'rounded',
            bg: 'background.neutral.tertiary.default',
            color: 'text.neutral.secondary.default'
        }
    }),
    // randomColor variant keeps Chakra default properties
    randomColor: definePartsStyle({})
};
const SIZES = [
    'size.s',
    'size.m',
    'size.l',
    'size.xl',
    'size.2xl',
    'size.3xl',
    '100%'
];
const BREAKPOINTS = {
    medium: 48,
    large: 128
};
const getFontVariant = (size)=>{
    if (size === 'size.3xl') {
        return 'display.m';
    } else if (size === 'size.2xl' || size === 'size.xl') {
        return 'heading.m';
    } else {
        return 'body.xs.default';
    }
};
const getSizes = ()=>{
    return Object.fromEntries(SIZES.map((size)=>[
            size,
            definePartsStyle({
                container: {
                    width: size,
                    height: size
                },
                label: _object_spread({}, getTypographyStyles(getFontVariant(size))),
                excessLabel: _object_spread_props(_object_spread({}, getTypographyStyles(getFontVariant(size))), {
                    width: size,
                    height: size
                })
            })
        ]));
};
export const ThemedAvatar = defineMultiStyleConfig({
    variants,
    sizes: getSizes()
});
const Avatar = forwardRef(function Avatar(_param, ref) {
    var { variant = 'randomColor', size = 'size.xl', isHoverEnabled = false, _hover } = _param, props = _object_without_properties(_param, [
        "variant",
        "size",
        "isHoverEnabled",
        "_hover"
    ]);
    const avatarRef = useRef(null);
    const [isFullSize, setIsFullSize] = useState(false);
    const [matchingTypographySize, setMatchingTypographySize] = useState(null);
    useEffect(()=>{
        var _avatarRef_current;
        if (size === '100%' && (avatarRef === null || avatarRef === void 0 ? void 0 : (_avatarRef_current = avatarRef.current) === null || _avatarRef_current === void 0 ? void 0 : _avatarRef_current.clientWidth)) {
            setIsFullSize(true);
            if (avatarRef.current.clientWidth >= BREAKPOINTS.large) {
                setMatchingTypographySize('size.3xl');
            } else if (avatarRef.current.clientWidth >= BREAKPOINTS.medium) {
                setMatchingTypographySize('size.xl');
            } else {
                setMatchingTypographySize('size.s');
            }
        }
    }, [
        size
    ]);
    return /*#__PURE__*/ _jsx(ChakraAvatar, _object_spread(_object_spread_props(_object_spread({}, isFullSize && {
        boxSize: '100%'
    }), {
        variant: variant,
        size: isFullSize && matchingTypographySize ? matchingTypographySize : size,
        _hover: _object_spread({}, _hover, isHoverEnabled && {
            opacity: 0.76,
            transition: 'opacity .2s ease-in-out'
        }),
        ref: mergeRefs(avatarRef, ref)
    }), props));
});
export { Avatar };

//# sourceMappingURL=index.js.map